import React from 'react'

export function HeaderWishlist ({...props}) {
    const {ruta = '/login'} = props

    return(
        <a
            href={ruta}
            className="heartIcon"
            aria-label="Ir a Wishlist"
        >
            <span className="textReference">
                <span className="smallText"></span> 
            </span>
        </a>
    )
}